import { useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import z from "zod";
import { CopyInput } from "@/components/copy-input";
import { Field, FieldGroup, FieldLabel } from "@/components/ui/field";
import {
	FormCard,
	FormCardContent,
	FormCardHeader,
	FormCardTitle,
} from "@/components/ui/form-card";
import { formatDate } from "@/lib/format";
import { orpc } from "@/orpc/client";

export const Route = createFileRoute("/_app/publishers/$publisherId/settings")({
	component: Page,
	params: z.object({
		publisherId: z.coerce.number(),
	}),
	async loader({ context, params, preload }) {
		if (!preload) {
			return;
		}

		context.queryClient.prefetchQuery(
			orpc.publishers.show.queryOptions({
				input: {
					publisherId: params.publisherId,
				},
			}),
		);
	},
});

function Page() {
	const params = Route.useParams();

	const { data: publisher } = useSuspenseQuery(
		orpc.publishers.show.queryOptions({
			input: {
				publisherId: params.publisherId,
			},
		}),
	);

	return (
		<div className="grid grid-cols-12 gap-6 px-4 lg:px-6">
			<FormCard className="col-span-12">
				<FormCardHeader>
					<FormCardTitle>Publisher Meta</FormCardTitle>
				</FormCardHeader>
				<FormCardContent>
					<FieldGroup>
						<Field className="lg:col-span-6">
							<FieldLabel>Publisher ID</FieldLabel>
							<CopyInput value={publisher.ID.toString()} readOnly />
						</Field>
						<Field className="col-start-1! lg:col-span-6">
							<FieldLabel>Updated Date</FieldLabel>
							<CopyInput value={formatDate(publisher.UpdatedDate)} readOnly />
						</Field>
						<Field className="lg:col-span-6">
							<FieldLabel>Created Date</FieldLabel>
							<CopyInput value={formatDate(publisher.CreatedDate)} readOnly />
						</Field>
					</FieldGroup>
				</FormCardContent>
			</FormCard>
		</div>
	);
}
